(function () {
  const SELECTOR = '[data-universo-lagea]';
  const VISIBLE_COUNT = 3;
  const MOBILE_QUERY = '(max-width: 749px)';

  class UniversoLagea {
    constructor(root) {
      this.root = root;
      this.panels = Array.from(root.querySelectorAll('[data-universo-panel]'));
      this.infoRoot = root.closest('.universo-lagea')?.querySelector('[data-universo-info]');
      this.infoPanels = this.infoRoot
        ? Array.from(this.infoRoot.querySelectorAll('[data-info-panel]'))
        : [];
      this.activeIndex = 0;
      this.windowStart = 0;
      this.mobileMedia = window.matchMedia(MOBILE_QUERY);
      this.hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (!this.panels.length) return;

      this.bindEvents();
      this.applyMode();
    }

    get isMobile() {
      return this.mobileMedia.matches;
    }

    get visibleCount() {
      return Math.min(VISIBLE_COUNT, this.panels.length);
    }

    get maxWindowStart() {
      return Math.max(0, this.panels.length - this.visibleCount);
    }

    bindEvents() {
      this.panels.forEach((panel, index) => {
        if (this.hasFinePointer) {
          panel.addEventListener('mouseenter', () => {
            if (!this.isMobile) this.setActive(index);
          });
        }

        panel.addEventListener('click', (event) => {
          event.preventDefault();
          const panelLink = panel.dataset.panelLink;

          if (panelLink && !this.isMobile) {
            window.location.assign(panelLink);
            return;
          }

          if (this.isMobile) {
            this.slideTo(index);
          } else {
            this.setActive(index);
          }
        });

        panel.addEventListener('focus', () => {
          if (this.isMobile) {
            this.slideTo(index);
          } else {
            this.setActive(index);
          }
        });
      });

      this.mobileMedia.addEventListener('change', () => this.applyMode());
    }

    applyMode() {
      this.windowStart = 0;
      this.updateWindow();
      this.setActive(0, false);
    }

    isVisible(index) {
      return index >= this.windowStart && index < this.windowStart + this.visibleCount;
    }

    slideTo(index) {
      let nextStart = index - 1;
      if (nextStart < 0) nextStart = 0;
      if (nextStart > this.maxWindowStart) nextStart = this.maxWindowStart;

      if (nextStart !== this.windowStart) {
        this.windowStart = nextStart;
        this.updateWindow();
      }

      this.setActive(index);
    }

    updateWindow() {
      if (this.windowStart > this.maxWindowStart) this.windowStart = this.maxWindowStart;
      if (this.windowStart < 0) this.windowStart = 0;

      this.panels.forEach((panel, i) => {
        const visible = this.isVisible(i);
        const restricted = this.isMobile && !visible;
        panel.classList.toggle('is-in-window', !this.isMobile || visible);
        panel.setAttribute('aria-hidden', restricted ? 'true' : 'false');
        panel.tabIndex = restricted ? -1 : 0;
      });
    }

    setActive(index, animate = true) {
      if (index < 0 || index >= this.panels.length) return;
      if (index === this.activeIndex && animate) return;

      this.activeIndex = index;

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        panel.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.updateInfo(index, animate);
    }

    updateInfo(index, animate) {
      if (!this.infoPanels.length) return;

      const nextPanel = this.infoPanels[index];
      if (!nextPanel) return;

      const current = this.infoPanels.find((panel) => panel.classList.contains('is-visible'));
      if (current === nextPanel) return;

      const showNext = () => {
        this.infoPanels.forEach((panel) => {
          panel.classList.remove('is-visible');
          panel.setAttribute('aria-hidden', 'true');
          panel.inert = true;
        });
        nextPanel.classList.add('is-visible');
        nextPanel.setAttribute('aria-hidden', 'false');
        nextPanel.inert = false;
      };

      const useMotion =
        animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!useMotion) {
        showNext();
        return;
      }

      if (current) current.classList.remove('is-visible');
      window.setTimeout(showNext, current ? 180 : 0);
    }
  }

  function initAll(scope) {
    const context = scope || document;
    context.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.universoLageaInstance) return;
      root.universoLageaInstance = new UniversoLagea(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
